import { Checkbox } from "../Components/Form/Checkbox";
import { AbstractFormElement } from "../Components/Form/Abstract";

class ShowThis {
    static INITIATORS = {
        showThis: "[data-show-this]"
    };

    private showThisInitiator: Checkbox;

    constructor(showThisInitiator: Checkbox) {
        this.showThisInitiator = showThisInitiator;
        this.initListener();
    }

    initListener() {
        const targetId = this.showThisInitiator.dataset.showThis;
        const targetElement = document.querySelector<any>(`#${targetId}`);
        if (targetElement && !this.showThisInitiator.checked) {
            targetElement.classList.add("hide-me");
            targetElement.disabled = true;
        }

        this.showThisInitiator.addEventListener("click", () => {
            const checked = this.showThisInitiator.checked;
            this.showInput(targetId, targetElement, checked);
            this.showThisInitiator.dispatchEvent(new Event("change"));
            targetElement.dispatchEvent(new Event("change"));
        });
    }

    showInput(targetId: string, targetElement: AbstractFormElement, checked: boolean) {
        if (targetElement) {
            targetElement.classList.toggle("hide-me", !checked);
            targetElement.value = !checked ? "" : targetElement.value;
            this.toggleAttributes(targetElement, checked);
        }
    }

    toggleAttributes(targetElement: AbstractFormElement, checked: boolean) {
        if (targetElement) {
            targetElement.disabled = !checked;
        }
    }
}

export { ShowThis };

const showThisInitiators = document.querySelectorAll<Checkbox>(ShowThis.INITIATORS.showThis);
if (showThisInitiators.length > 0) {
    showThisInitiators.forEach((initiator) => {
        new ShowThis(initiator);
    });
}
